import { CarrierVisitDirection } from '@planning/app/api'
import { orderService } from '@planning/services'
import { useTranslate } from '@tolgee/react'
import { FieldStore } from '@tom-ui/utils'
import { useCallback } from 'react'

export const useValidateBulkMove = () => {
  const { t } = useTranslate()

  const validate = useCallback(
    async (
      store: FieldStore<any>,
      direction: CarrierVisitDirection,
      entityId: number,
      selectedContainerNumbers: string[],
    ): Promise<boolean> => {
      store.setError(undefined)

      if (!entityId) {
        return true
      }

      try {
        const containerNumbers = selectedContainerNumbers

        const conflictingContainers = await orderService.validateBulkMove(
          containerNumbers,
          entityId,
          direction,
        )

        if (conflictingContainers.length > 0) {
          const containerList = conflictingContainers.join(', ')
          const errorMessage = t(
            'bulkMoveConflict',
            'The following containers are already in the selected visit: {containers}',
            { containers: containerList },
          )
          store.setError(errorMessage)
          return false
        }

        return true
      } catch (error) {
        console.error('Validation failed:', error)
        return false
      }
    },
    [t],
  )

  return { validate }
}
